var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import cx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { Logo } from "../Logo";
import { Nav } from "../Nav";
import { Cta } from "../Cta";
import { UserAccountMenu } from "../UserAccountMenu";
import { HelpButton } from "../HelpButton";
import { Overlay } from "../Overlay";
export var Menu = function (_a) {
    var _b = _a.data.menu, elements = _b.elements, ctas = _b.ctas, helpButton = _b.helpButton, useUserAccount = _a.useUserAccount, forceUseUserAccount = _a.forceUseUserAccount, businessUnit = _a.businessUnit, country = _a.country, messages = _a.messages, searchCategories = _a.searchCategories, enviroment = _a.enviroment, section = _a.section;
    var isMenuEnabled = forceUseUserAccount
        ? forceUseUserAccount
        : section !== "sem" && useUserAccount;
    var _c = useState(false), isOpen = _c[0], setOpen = _c[1];
    var _d = useState(false), isUserAccountOpen = _d[0], setUserAccountOpen = _d[1];
    var _e = useState(false), hasCategoryOpen = _e[0], setHasCategoryOpen = _e[1];
    var hasCtas = Boolean(ctas && ctas.length);
    var navClass = cx({
        "max-h-0": !isOpen,
        "max-h-68": isOpen && !hasCategoryOpen,
        "max-h-360": isOpen && hasCategoryOpen,
    });
    return (React.createElement("section", { className: "border-b border-gray-100" },
        React.createElement("div", { className: "menu-root bg-white flex flex-nowrap justify-between md:max-w-7xl mx-auto md:px-6 lg:px-0 z-40 relative" },
            React.createElement(Logo, null),
            React.createElement(Nav, { className: navClass, setHasCategoryOpen: setHasCategoryOpen, categories: elements }, helpButton && React.createElement(HelpButton, __assign({}, helpButton))),
            React.createElement("div", { className: "flex justify-between items-center" },
                isMenuEnabled && (React.createElement("div", { className: "order-2 ml-4 md:order-none md:ml-0", "data-testid": "user-account-container" },
                    React.createElement(UserAccountMenu, { businessUnit: businessUnit, country: country, messages: messages, isNavbarOpen: isOpen, setNavbarOpen: setOpen, isOpen: isUserAccountOpen, setOpen: setUserAccountOpen }))),
                hasCtas && (React.createElement("div", { className: "flex order-1 md:order-none" }, ctas.map(function (cta, index) { return (React.createElement(Cta, __assign({ key: index }, cta, { country: country, businessUnit: businessUnit, messages: messages, searchCategories: searchCategories, enviroment: enviroment }))); }))),
                hasCtas && (React.createElement("div", { className: "w-px h-3/5 my-4 ml-4 bg-gray-50 md:hidden order-3 md:order-none md:ml-0" })),
                React.createElement("button", { "data-testid": "menu-button", type: "button", className: "md:hidden w-15 h-16 p-4 text-xl leading-none order-4 focus:outline-none md:order-none", onClick: function () { return setOpen(!isOpen); } },
                    React.createElement(FontAwesomeIcon, { icon: isOpen ? faTimes : faBars, className: "text-gray-200", size: "1x", "data-testid": "menu-icon-button", width: "18", height: "20" })))),
        React.createElement(Overlay, { isOpen: isOpen || isUserAccountOpen })));
};
//# sourceMappingURL=Menu.js.map